import { UserRoles } from "./constants/common.constants";
import { CLAIM_CORRECTION_URL } from "./constants/api.constants";
import { getUserRole } from "../views/pending-claims/data-access";


const GetOriginalRole = async (accounts : any) => {
      let role: any = [];
      accounts && accounts[0]?.idTokenClaims?.roles?.map((item: any) => {
        role.push(item);
      });
      let userRole : any = ""
      if(role?.length === 0) {
        userRole = await getUserRoleFromBackend();
      }
      else {
        role?.forEach( (element : string) => {
          if (element?.toLowerCase() === UserRoles.ICD10_CCT.toLowerCase() || element?.toLowerCase() === UserRoles.ICD10_GM.toLowerCase() 
            || element?.toLowerCase() === UserRoles.ICD10_CM.toLowerCase() || element?.toLowerCase() === UserRoles.ICD10_OTHER.toLowerCase() 
            || element?.toLowerCase() === UserRoles.ICD10_DM.toLowerCase() || element?.toLowerCase() === UserRoles.ICD10_CEC.toLowerCase()) {
          userRole = element
        }
        else 
         userRole = UserRoles.ICD10_OD        
      })}
      return userRole;
};

const getUserRoleFromBackend = async () => {
    let role = ""     
    try {          
        const res = await getUserRole(CLAIM_CORRECTION_URL.GET_USER_ROLE, {})
        if(res.status === 200) {    
          role = getRoleByNumber(res?.data?.RoleId) 
          localStorage.setItem("userRole", role);     
        }
    } catch (err) {
      console.log(err?.message);
    }
    return role
};

const roleMapping: { [key: number]: UserRoles } = {
  1: UserRoles.ICD10_OD,
  2: UserRoles.ICD10_GM,
  3: UserRoles.ICD10_CCT,
  4: UserRoles.ICD10_CM,
  5: UserRoles.ICD10_OTHER,
  6: UserRoles.ICD10_DM,
};

const  getRoleByNumber =(roleNumber: number) => {
  return roleMapping[roleNumber];
}

export const GetUserRole = async(accounts : any) => {
   return process.env.REACT_APP_IS_PROD?.toString() === "Y" ? await GetOriginalRole(accounts)  : localStorage.getItem("userRole") ===  null ? await GetOriginalRole(accounts) : localStorage.getItem("userRole")
}


